export const SOURCE = 'source';
export const PROPERTY_NAME = 'propertyName';
export const ASSOCIATION_SPEC = 'associationSpec';